module.exports = __webpack_public_path__ + "img/melilla.6afccb22.svg";